<template>
	<section class="wrapper" :style="background_style">
		<div class="header">
			<a href="https://www.datapas.nl/" target="_blank">
				<img :src="datapas_logo" alt="Datapas website">
			</a>
		</div>
		<div class="auth-body">
			<header class="body-title">
				<span class="title">
					<slot name="title"/>
				</span>
			</header>
			<section>
				<slot name="default"/>
			</section>
		</div>
	</section>
</template>
<script>
export default {
	name: "AuthPage",
	computed: {
		datapas_logo() {
			return this.$definitions.datapas_logo_url;
		},
		background_style() {
			return this.$definitions.login_background_style;
		}
	},
};
</script>
<style scoped lang="scss">
@use "@datapas/scss-framework/src/vars.scss";
@use "../scss/auth.scss";

$HEADER_HEIGHT: 40px;
$BODY_SPACING: calc(vars.$CONTENT-SPACING * 1.5);

.wrapper {
	background-position: top center;
	background-repeat: no-repeat;
	background-size: cover;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;

	& .header {
		background-color: vars.$DATAPAS-MAIN-COLOR;
		box-sizing: border-box;
		height: $HEADER_HEIGHT;
		left: 0;
		position: absolute;
		top: 0;
		width: 100%;
		padding: 5px;

		& img {
			height: 100%;
		}
	}

	& .auth-body {
		background-color: vars.$WHITE-COLOR;
		border-radius: vars.$BORDER-RADIUS-MEDIUM;
		box-shadow: vars.$BOX-SHADOW;
		display: inline-block;
		padding: $BODY_SPACING;
		text-align: left;
		transition: all vars.$TRANSFORM-DURATION-SHORT ease;
		width: auto;

		& .body-title {
			display: none;
			margin-bottom: vars.$CONTENT-SPACING;
			width: 100%;

			&:has(.title > *) {
				display: block;
			}

			& .title {
				align-items: center;
				border-bottom: vars.$BORDER-WIDTH solid vars.$DATAPAS-MAIN-COLOR;
				color: vars.$DATAPAS-MAIN-COLOR;
				display: flex;
				font-weight: bold;
				justify-content: space-between;
				overflow: auto;
				padding: 0 0 vars.$CONTENT-SPACING-GEGROEPEERD;
				font-size: auth.$AUTH_TITLE_FONT_SIZE;
			}
		}
	}
}

</style>